<template>
    
    <div id="chome-container" :class="[(showVideo && !loading)?'bg-back':'']">

       <div class="box" v-if="loading">
        <img :src="constants.images.logo" class="image-logo-21" />
         <div class="radar">
            <img src="../assets/images/home/circle.png" alt="">
            <img class="map" src="../assets/images/home/map.png" alt="">
         </div>
         <div class="loadBtn" @click="clickLoadBtn">{{startNansha}}</div>
       </div>

       <div v-show="showVideo && !loading" style="text-align: center">

            <!-- <video @loadstart="start" @durationchange="durationChange" controls width="100%" height="100%" id="home-video">
                <source :src="mp4Url">
            </video> -->
            <video class="video" id="home-video" x5-video-player-type="h5" x5-video-player-fullscreen="true" x5-video-orientation="portrait" playsinline webkit-playsinline="false">
                <source :src="mp4Url">
            </video>

            <img :src="constants.images.nextBtn" @click="goIndex" id="home-next-btn" />
        </div>
        
        <div id="chome-bg" v-if="!showVideo && !loading">

            <img :src="constants.images.bgPoint" class="image-home-bg-point" />

            <img :src="constants.images.bgPoint1" class="image-home-bg-point-1" />
            
            <img :src="constants.images.logo" class="image-logo-21" />

            <img :src="constants.images.title" class="image-home-title" />

            <HomeMap />

            <img 
                :src="constants.images.searchBtn" 
                class="image-home-search-btn" 
                @click="goToSearch"
            />
        </div>

        
    </div>
</template>

<script>

    import HomeMap from "@/components/HomeMap";

    import Imagelogo21 from "@/assets/images/21logo.png";
    import ImageTitle from "@/assets/images/home/title.png";
    import ImageMap from "@/assets/images/home/map.png";
    import ImageSearchBtn from "@/assets/images/home/search-btn.png";
    import ImageBgPoint1 from "@/assets/images/home/bg-point-1.png";
    import ImageCpFoshan from "@/assets/images/home/cp-foshan.png";
    import ImageCpZhongshan from "@/assets/images/home/cp-zhongshan.png";
    import ImageCpAomen from "@/assets/images/home/cp-aomen.png";
    import ImageCpHongKong from "@/assets/images/home/cp-hongkong.png";
    import ImageCpDongGuan from "@/assets/images/home/cp-dongguan.png";
    import ImageArrow from "@/assets/images/home/arrow.png";
    import ImageBgPoint from "@/assets/images/home/bg-point.png";
    import ImageNextBtn from "@/assets/images/home/next-btn.png";

    export default {
        name: "CHome",
        components: {
            HomeMap
        },
        data() {
            return {
                constants: {
                    images: {
                        logo: Imagelogo21,
                        title: ImageTitle,
                        map: ImageMap,
                        searchBtn: ImageSearchBtn,
                        bgPoint1: ImageBgPoint1,
                        cpFoshan: ImageCpFoshan,
                        cpZhongshan: ImageCpZhongshan,
                        cpAomen: ImageCpAomen,
                        cpHongkong: ImageCpHongKong,
                        cpDongguan: ImageCpDongGuan,
                        arrow: ImageArrow,
                        bgPoint: ImageBgPoint,
                        nextBtn: ImageNextBtn
                    }
                },
                mp4Url: "http://recordcdn.quklive.com/upload/vod/user1460445333221835/1656320824503131/4/video.mp4",
                showVideo: false,
                loading: true,
                loadingPre: 0,
                timer: null,
                startNansha: '开启南沙',
                startTime: 0,
                endTime: 0,
            }
        },
        destroyed() {
            clearInterval(this.timer)
        },
        // created() {
        //     this.loadHandler()
        // },
        mounted() {

        },
        methods: {

            loadHandler(time = 50) {
                this.timer = setInterval(()=>{
                    if(this.loadingPre === 100 ) {
                        clearInterval(this.timer)
                    }else {
                        this.loadingPre += 2;
                    }
                },time)
            },

            clickLoadBtn() {
                // if(this.loadingPre !== 100) {
                //     return;
                // }
                // console.log('click1111');
                this.loading = false;
                this.showVideo = true;

                let videoId = document.getElementById("home-video");
                videoId.load();

                videoId.play();

                this.timer = setTimeout(() => {
                    if(this.showVideo) {
                        this.goIndex()
                    }
                },11000)
                // console.log(document.getElementById("home-video").duration, '99999');
                videoId.addEventListener("ended", () => {
                    this.goIndex()
                    console.log(456);
                }, false);
            },

            start(e) {
                // console.log('456888', e);
                this.startTime = e.timeStamp
            },

            videoCanplay(e) {
                this.end = e.timeStamp;
                let time = (this.endTime - this.startTime) / 10;
                this.loadHandler(time);
            },
            durationChange(e) {
                this.end = e.timeStamp;
                let time = (this.endTime - this.startTime) / 10;
                this.loadHandler(time);
            },


            goToSearch() {
                this.$router.push({
                    name: "Search"
                });
            },
            goIndex() {
                this.showVideo = false;
                this.timer = null
                // document.getElementById("home-video").pause();
            }
        }
    }
</script>

<style lang="scss" scoped>
    .video {
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        object-fit: fill;/*这里是关键*/
    }
    .box{
        width: 100%;
        height: 75%;
        /* 弹性布局 水平、垂直居中 */
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

    .radar{
        width: 19rem;
        height: 19rem;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
            width: 19rem;
        }
        .map {
            position: absolute;
            width: 5rem;
            left: 7rem;
            top: 6rem;
        }
       
        position: relative;
        // border-radius: 50%;
    }
    .radar::before{
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        background: url(../assets/images/home/transform.png) no-repeat;
        background-size: 100%;
        // top: 4%;
        // left: 4%;
        /* 执行动画: 动画名称 时长 线性的 无限次播放 */
        animation: scanning 5s linear infinite;
        z-index: 1;
    }

    /* 定义动画 */
    @keyframes scanning {
        to{
            transform: rotate(360deg);
        }
    }

    .loadBtn {
        width: 10rem;
        // height: 59px;
        color: #fff;
        font-size: 1rem;
        background: url(../assets/images/home/loadingBtn.png) no-repeat;
        background-size: 100%;
        line-height: 2.6rem;
        text-align: center;
    }

    #home-video {
        height: 100vh;
    }

    #home-next-btn {
        position: fixed;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    @media screen and (min-height: 800px) {
        .bg-back {
            background: #000 !important;
        }
        .image-logo-21 {
                width: 67.9%;
                position: fixed;
                left: calc((100% - 67.9%) / 2);
                top: 6.5%;
        }
        #chome-container {
            background: url(../assets/images/home/bg.png);
            position: fixed;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            background-position: 50% 50%;
            background-size: cover;
            background-repeat: no-repeat;

            #chome-bg {

                position: fixed;
                top: -5%;
                left: 0;
                bottom: 0;
                right: 0;
                background-position: 50% 50%;
                background-size: contain;

                .image-home-bg-point {
                    width: 100%;
                    position: fixed;
                    top: -2.5%;
                    animation: scaleAndRotate 7s linear 0.2s infinite;
                }

                @keyframes scaleAndRotate {
                    100% {
                        transform: scale(1.5);
                    }
                }

                .image-home-bg-point-1 {
                    width: 100%;
                    position: fixed;
                    top: 20%;
                }

                .image-home-map {
                    background-image: url(@/assets/images/home/map.png);
                    background-position: 50% 50%;
                    width: 100vw;
                    height: 78vh;
                    background-size: contain;
                    background-repeat: no-repeat;
                    position: fixed;
                    bottom: 0;
                }

                // .image-logo-21 {
                //     width: 67.9%;
                //     position: fixed;
                //     left: calc((100% - 67.9%) / 2);
                //     top: 6.5%;
                // }

                .image-home-title {
                    width: 80%;
                    position: fixed;
                    left: 20%;
                    top: 14%;
                }

                .image-home-search-btn {
                    position: fixed;
                    bottom: 5.7%;
                    width: 37%;
                    left: calc((100% - 37%) / 2);
                }

                #image-home-cp-foshan {
                    position: relative;
                    top: 48.3%;
                    left: 5%;
                    width: 16.8%;
                }

                #image-home-cp-zhongshan {
                    position: relative;
                    top: 62%;
                    left: 12%;
                    width: 17.8%;
                }

                #image-home-cp-aomen {
                    position: relative;
                    top: 72.6%;
                    left: 23%;
                    width: 12.3%;
                }

                #image-home-cp-hongkong {
                    position: relative;
                    top: 50.9%;
                    left: 37%;
                    width: 14.8%;
                }

                #image-home-cp-dongguan {
                    position: relative;
                    top: 31.2%;
                    right: 4%;
                    width: 19.6%;
                }

                #image-home-arrow-1 {
                    position: relative;
                    right: 72.5%;
                    top: 34.3%;
                    width: 1.8rem;
                }
            }
        }
    }

    @media screen and (max-height: 800px) {
         .bg-back {
            background: #000 !important;
        }
        .image-logo-21 {
                    width: 67.9%;
                    position: fixed;
                    left: calc((100% - 67.9%) / 2);
                    top: 6.5%;
                }
        #chome-container {
            background-image: url(../assets/images/home/bg.png);
            position: fixed;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            background-position: 50% 50%;
            background-size: cover;
            background-repeat: no-repeat;

            #chome-bg {

                position: fixed;
                top: -5%;
                left: 0;
                bottom: 0;
                right: 0;
                background-position: 50% 50%;
                background-size: contain;

                .image-home-bg-point {
                    width: 100%;
                    position: fixed;
                    top: -9%;
                    animation: scaleAndRotate 7s linear 0.2s infinite;
                }
                
                 @keyframes scaleAndRotate {
                    100% {
                        transform: scale(1.5);
                    }
                }
                .image-home-bg-point-1 {
                    width: 100%;
                    position: fixed;
                    top: 20%;
                }

                .image-home-map {
                    background-image: url(@/assets/images/home/map.png);
                    background-position: 50% 50%;
                    width: 100vw;
                    height: 78vh;
                    background-size: contain;
                    background-repeat: no-repeat;
                    position: fixed;
                    bottom: 0;
                }

                // .image-logo-21 {
                //     width: 67.9%;
                //     position: fixed;
                //     left: calc((100% - 67.9%) / 2);
                //     top: 6.5%;
                // }

                .image-home-title {
                    width: 70%;
                    position: fixed;
                    left: 24%;
                    top: 14%;
                }

                .image-home-search-btn {
                    position: fixed;
                    bottom: 5.7%;
                    width: 37%;
                    left: calc((100% - 37%) / 2);
                }

                #image-home-cp-foshan {
                    position: relative;
                    top: 48.3%;
                    left: 5%;
                    width: 16.8%;
                }

                #image-home-cp-zhongshan {
                    position: relative;
                    top: 62%;
                    left: 12%;
                    width: 17.8%;
                }

                #image-home-cp-aomen {
                    position: relative;
                    top: 72.6%;
                    left: 23%;
                    width: 12.3%;
                }

                #image-home-cp-hongkong {
                    position: relative;
                    top: 50.9%;
                    left: 37%;
                    width: 14.8%;
                }

                #image-home-cp-dongguan {
                    position: relative;
                    top: 31.2%;
                    right: 4%;
                    width: 19.6%;
                }

                #image-home-arrow-1 {
                    position: relative;
                    right: 72.5%;
                    top: 34.3%;
                    width: 1.8rem;
                }
            }
        }
    }
</style>